<template lang="pug">
   .mainContainer
    el-row.header
      el-col(:span="12")
        .header-36-black แมทซ์ผู้ดูแล
      el-col.close-icon(:span="12")
          i.el-icon-close.close.header-36-black(@click="goToSchedule")
    el-row
      el-collapse(accordion)
        el-collapse-item
          template(slot="title")
            div(style="display: flex; flex-direction: column;")
              .bookingHeader {{ header }}
              .bookingSubHeader {{ subheader }}
              .bookingSubHeader &nbsp;
          matching-detail(:detail="detail")
    el-row(v-if="stats")
      el-col(:span="12.5").numberTitleHeader
        .numberTitleHeader-header ส่งงานให้ผู้ดูแล {{ stats.sent }} &nbsp;
      el-col(:span="12.5").numberHeader
        .numberHeader-head(style="margin-right: 17px;") ผู้ดูแลเห็นงานแล้ว: &nbsp;
        .numberHeader-head สนใจ &nbsp;
        .numberHeader-number {{ stats.accepted }}
        .numberHeader-head ปฏิเสธ &nbsp;
        .numberHeader-number {{ stats.rejected }}
        .numberHeader-head ไม่ตอบ &nbsp;
        .numberHeader-number {{ stats.seen }}
        .numberHeader-head(style="margin-left: 10px; border-right: solid 1px;")
        .numberHeader-head(style="margin-left: 21px;") ผู้ดูแลยังไม่เห็นงาน &nbsp;
        .numberHeader-number {{ stats.inactive }}
    el-row
      matching-table(v-if="list",
        :caregiversList="list",
        :canSendCgProfile="canSendCgProfile",
        :fake="fake"
        @rejectCaregiver="rejectCaregiver",
        @approveCaregiver="approveCaregiver",
        @sendCaregiverProfile="sendCaregiverProfile")
</template>

<style lang="scss" scoped>
  .mainContainer {
    padding: 155px 100px 20px 100px;
  }

  .right {
    text-align: right;
  }
  .header {
    padding: 40px 0;
  }

  .el-button {
    width: 120px;
  }

  hr {
    background-color: #dcdfe6;
    height: 1px;
    border: 0;
  }

  .bookingHeader {
    font-family: 'Sukhumvit-Bold';
    font-size: 22px;
    color: #909399;
    margin-top: 12px;
    margin-bottom: 1px;
    line-height: 20px;
  }

  .bookingSubHeader {
    font-size: 14px;
    color: #909399;
    line-height: 20px;
  }

  .close-icon {
    display: flex;
    justify-content: flex-end;
    padding-right: 33px;
  }

  .close {
    color: #303133;
    font-weight: 900;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .el-main {
    padding-right: 35px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .numberTitleHeader {
    margin: 35px 0 32px 0;
    display: flex;
    flex-direction: row;
    background-color: #e4e7ed;
    padding: 8px 36px 8px 14px;
    border-top-left-radius: 3.6px;
    border-bottom-left-radius: 3.6px;
  }

  .numberTitleHeader-header {
    font-family: 'Sukhumvit-Bold';
    color: #606266;
    font-size: 18px;
  }

  .numberHeader {
    margin: 35px 0 32px 0;
    display: flex;
    flex-direction: row;
    background-color: #f5f7fa;
    padding: 8px 14px;
    border-radius: 3.6px;
  }

  .numberHeader-head {
    font-family: 'Sukhumvit-Bold';
    color: #c0c4cc;
    font-size: 18px;
  }

  .numberHeader-number {
    font-family: 'Sukhumvit-Bold';
    color: #606266;
    font-size: 18px;
    margin-right: 16px;
  }

  .el-collapse {
    padding-top: 17px;
  }
</style>

<script>
import MatchingTable from '@/components/matching/MatchingTable'
import MatchingDetail from '@/components/matching/MatchingDetail'
import MatchingTableRowModel from '../../model/MatchingTableRowModel'

export default {
  name: 'MatchingBoard',
  mounted () {
    this.getCaregiverslist()
  },
  components: {
    MatchingTable,
    MatchingDetail,
  },
  props: {
    reservationId: {
      type: Number,
      required: true,
    },
    patientId: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      header: '',
      subheader: '',
      stats: {
        sent: 0,
        accepted: 0,
        rejected: 0,
        seen: 0,
        inactive: 0,
      },
      list: [],
      detail: {},
      fake: false,
      canSendCgProfile: false,
    }
  },
  methods: {
    async approveCaregiver (caregiverId) {
      try {
        await this.$api.Job.matchJob(this.id, caregiverId)
        this.goToSchedule()
      } catch (error) {
        this.$message.error(error)
      }
    },
    async rejectCaregiver (caregiverId) {
      try {
        await this.$api.Job.unmatchJob(this.id, caregiverId)
        this.getCaregiverslist()
      } catch (error) {
        this.$message.error(error)
      }
    },
    async sendCaregiverProfile (caregiverId) {
      try {
        await this.$api.Job.sendCgProfile(this.id, caregiverId)
        this.getCaregiverslist()
      } catch (error) {
        this.$message.error(error)
      }
    },
    async getCaregiverslist () {
      try {
        const raw = await this.$api.Job.get(this.id)
        this.stats = raw.stats
        this.header = raw.header
        this.subheader = raw.subHeader
        this.detail = raw.detail
        this.canSendCgProfile = raw.canSendCgProfile
        this.fake = raw.fake
        this.list = raw.list.map((json) => MatchingTableRowModel.fromJSON(json))
      } catch (error) {
        this.$message.error(error)
      }
    },
    goToSchedule () {
      this.$router.push({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
    },
  },
}
</script>
